import { AgCharts as AgChartsEnterprise } from 'ag-charts-enterprise';

Object.defineProperty(AgChartsEnterprise, 'licenseManager', {
    configurable: true,
    set(v: any) {
        this._lm = v;
        v && handleLicense(v);
    },
    get() {
        return this._lm;
    },
});

function handleLicense(lm: any) {
    Object.assign(lm, {
        isDisplayWatermark: () => false,
        isLocalhost: () => true,
        outputMissingLicenseKey() {
            /* noop */
        },
    });
}
